import React from "react";
import ReducedManagerListWithQualities from "../../../commonComponents/ReducedManagerListWithQualities";
import useAppContext from "../../../../hooks/useAppContext";
import { AppContextType } from "../../../../context/AppContext";
import DateComponent from "../../../commonComponents/DateComponent";
import { DateType } from "../../../../static/types/commonTypes/dateType";
import ReducedManager from "../../../commonComponents/ReducedManager";
import ManagerListWithQualities from "../../../commonComponents/ManagerListWithQualities";
import ManagerWithQuality from "../../../commonComponents/ManagerWithQuality";
import { advencedFunctions } from "../../../../constant/company-modification/functions";

interface ChangeManagementAndPresidencyProps  {
    societyTypeOptions: string[]
}


const ChangeManagementAndPresidency: React.FC<ChangeManagementAndPresidencyProps> = ({
    societyTypeOptions
}) => {

    const {
        companyName, 

        reducedGeneralManagersWithQualite,
        setReducedGeneralManagersWithQualite,
        setReducedGeneralManagersWithQualiteValidity,
        reducedGeneralManagersWithQualiteChecked,
        
        managerAndPresidencyChange,
        setManagerAndPresidencyChange,

        managerWithQuality,
        setManagerWithQuality,
        setManagerWithQualityValidity,
        managerWithQualityChecked,
        setManagerWithQualityChecked,

        reducedStatutoryAuditor, setReducedStatutoryAuditor,
        setReducedStatutoryAuditorValidity,
        reducedStatutoryAuditorChecked, setReducedStatutoryAuditorChecked,

        generalManagersWithQualite,
        setGeneralManagersWithQualite,
        setGeneralManagersWithQualiteValidity,
        generalManagersWithQualiteChecked,
        
        presidencyChangeEffectiveDate,
        setPresidencyChangeEffectiveDate,
        setPresidencyChangeEffectiveDateValidity,
        presidencyChangeEffectiveDateChecked,

    } = useAppContext() as AppContextType

    const updateDate = (data: Partial<DateType>) => setPresidencyChangeEffectiveDate ({...presidencyChangeEffectiveDate, ...data});
   
    return (
        <div>
            <div className='col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor="modification" className="col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className='form-select w-75'
                    id="modificationCAC"
                    onChange={(e) => {
                        setManagerAndPresidencyChange (Number(e.target.value))
                    }}
                    value = {managerAndPresidencyChange}
                >
                        <option value={0}>Aucune modification</option>
                        <option value={1}>Départ</option>
                        <option value={2}>Remplacement</option>
                        <option value={3}>Ajout</option>
                </select>                            
            </div>
            {   
                managerAndPresidencyChange !== 0 &&
                    <div className="mt-3 col-sm-7">
                        <DateComponent
                            id='dateEffetManager'
                            date = { presidencyChangeEffectiveDate }
                            draftFieldName = "presidencyChangeEffectiveDate"
                            changeDate = { updateDate }
                            dateLabel = "Date d'effet"
                            checked = { presidencyChangeEffectiveDateChecked }
                            onValidationChange = {( isValid: boolean ) => setPresidencyChangeEffectiveDateValidity ( isValid )}
                            required = { false }
                        />
                    </div>
            }
            {
                managerAndPresidencyChange === 1 &&
                    <div style={{marginTop: '-40px !important'}}>
                        <ReducedManagerListWithQualities
                            checked= {reducedGeneralManagersWithQualiteChecked}
                            companyName={companyName}
                            managers={reducedGeneralManagersWithQualite}
                            setManagers={setReducedGeneralManagersWithQualite}
                            societyTypeOptions={societyTypeOptions}
                            qualitiesOptions = { advencedFunctions.map( functionItem => functionItem.singular )}
                            setManagersValidity={(isValid: boolean) => setReducedGeneralManagersWithQualiteValidity (isValid)}
                            addButtonText="Ajouter un dirigeant"
                            removeButtonText="Supprimer le dernier dirigeant"
                        />
                    </div>
            }

            {
                managerAndPresidencyChange === 2 &&
                    <div className="mt-3">
                        <div>
                            <h6 className='text-bold bg' style={{ backgroundColor: '#4DB0BB', padding: '10px' }}>
                                Arrivant
                            </h6>
                                <ManagerWithQuality
                                    manager = { managerWithQuality }
                                    setManager = { setManagerWithQuality }
                                    checked = { managerWithQualityChecked }
                                    setChecked = { setManagerWithQualityChecked }
                                    societyType = { societyTypeOptions }
                                    updateManagerValidity = {( isValid: boolean ) => setManagerWithQualityValidity( isValid )}
                                    qualitiesOptions = { advencedFunctions.map( functionItem => functionItem.singular )}
                                />
                            <h6 className='text-bold bg mt-2' style={{ backgroundColor: '#4DB0BB', padding: '10px' }}>
                                Partant
                            </h6>
                                <ReducedManager
                                    checked = { reducedStatutoryAuditorChecked }
                                    manager = { reducedStatutoryAuditor }
                                    draftFieldName = "reducedStatutoryAuditor"
                                    setChecked = { setReducedStatutoryAuditorChecked }
                                    setManager = { setReducedStatutoryAuditor }
                                    updateManagerValidity = {( isValid ) => setReducedStatutoryAuditorValidity ( isValid )}
                                />
                        </div>
                    </div>
            }

            {
                managerAndPresidencyChange === 3 &&
                    <div className="mt-3">
                        <div>
                            <ManagerListWithQualities
                                addButtonText='Ajouter un dirigeant'
                                removeButtonText='Supprimer le dernier dirigeant'
                                checked={generalManagersWithQualiteChecked}
                                managers={generalManagersWithQualite}
                                qualitiesOptions = { advencedFunctions.map( functionItem => functionItem.singular )}
                                setManagers={setGeneralManagersWithQualite}
                                setManagersValidity={setGeneralManagersWithQualiteValidity}
                                societyTypeOptions={societyTypeOptions}
                            />
                        </div>
                    </div>
            }
        </div>
        
    );
};
export default ChangeManagementAndPresidency;